module.exports = __webpack_public_path__ + "static/media/lucas-neomu-happy.8f625b7f.mp3";